<template>
  <div class="row">
    <div class="col-12">
      <div class="cont-heading d-flex justify-content-between align-items-center col-12 float-right">
        <div class="col-md-4">
<!--          <ChangeVersion v-if="user.core_role_id == 2"/>-->
          <h1 class="text-uppercase mb-0">{{title}}</h1>
        </div>
        <div class="col-md-3">
          <img src="@/assets/images/tipshift/desktop.png" width="260px"/>
          <span class="reloj-letras">
              {{ this.$moment().format("LL")  }}
          </span>
        </div>
        <div class="col-md-3 text-right">
          <div class="cont-user-info ml-3 d-flex align-items-center">
            <div class="cont-txt">
              <b-dropdown
                toggle-class="text-decoration-none"
                variant="link"
                size="lg"
                no-caret
                style="z-index: 50000;">
                <template #button-content>
                  <p class="desc text-upercase mb-0" align="left">
                    {{ user.name }}
                    <img class="centerImg1" src="@/assets/images/icons/chevron-down.svg">
                    </p>
                  <p class="desc text-upercase mb-0">{{ user.position }}</p>
                </template>
                <b-dropdown-item class="w-auto">
                  <router-link to="/profile" class="menu-button w-auto">         
                    <p class="name text-capitalize mb-0">Configurar perfil</p>
                  </router-link>
                </b-dropdown-item>
                <b-dropdown-item @click="closeSession">
                    <p class="name text-capitalize mb-0">Cerrar sesión</p>
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <div class="cont-symbol">
              <b-button v-b-toggle.sidebar-right size="lg" class="notification" variant="light">
                <span class="icon-bell"></span>
                <span class="badge" v-show="this.unread>0">{{this.unread}}</span>
              </b-button>
              <b-sidebar id="sidebar-right" title="NOTIFICACIONES" right backdrop shadow>
                <div class="px-5 py-5" style="background-color: #FFFFFF">
                  <div v-for="data in this.notificationRol" :key="data.notification_id">
                    <a href="#" @click="routeTo(data.license_id,data.notification_id)">
                      <div v-if="data.read_at != 'null'">
                        <div class="row" style="background-color: #FFFFFF">
                          <div class="col-7 mb-md-0">
                            <p class="text">{{data.time}}</p>
                          </div>
                          <div class="col-5 mb-md-0" align="right" style="background-color: #FFFFFF">
                            <p class="text">Solicitud: {{data.license_id}}</p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 mb-md-0"  align="left" style="background-color: #FFFFFF">
                            <p class="text">{{data.text}}</p>
                          </div>
                        </div>
                        <div class="col-12 mb-md-0" style="background-color: #FFFFFF">
                          <p class="text"><b>Leido: {{data.read_at}}</b></p>
                        </div>
                        <div class="row">
                          <div class="col-12 mb-md-0" align="left" style="background-color: #FFFFFF">
                            <img src="@/assets/images/icons/bar2.svg">
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div class="row" style="background-color: #eae8e4">
                          <div class="col-7 mb-md-0 mt-2">
                            <p class="text2"><b>{{data.time}}</b></p>
                          </div>
                          <div class="col-5 mb-md-0" align="right">
                            <p class="text2"><b><u>Solicitud: {{data.license_id}}</u></b></p>
                          </div>
                          <div class="col-12 mb-md-0"  align="left">
                            <p class="text2">{{data.text}}</p>                        
                          </div>
                        </div>                      
                        <div class="row" style="background-color: #eae8e4">
                          <div class="col-12 mb-md-0"  align="left">
                            <p class="text2"><b>**Sin leer**</b></p>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12 mb-md-0" align="left">
                            <img src="@/assets/images/icons/bar2.svg">
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>                  
                </div>
              </b-sidebar>
            </div>
          </div>
        </div>
        
        <!-- .cont-user-info -->
      </div>
      <!-- .cont-heading -->
    </div>
    <!-- .col -->
  </div>
  <!-- .row -->
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import serverConfig from "./../../services/config";
// import ChangeVersion from './ChangeVersion.vue'
import { clear } from '@/common/helps/local-storage'
export default {
  serverPath: serverConfig.permisosURL,
  name: "HeadingUserVP1",
  components: {
    // ChangeVersion
  },
  props: {
    title: {
      type: String,
      default: "Virtual Partner",
    },
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      notificationRol: [],
      unread: 0,
    };
  },
  beforeMount(){
    this.actGetNotifications().then(() =>{
      this.unread = this.notifications.data.unread;
      for(let i=0; i<this.notifications.data.notifications.length; i++){
        let stringJsonTmp = this.notifications.data.notifications[i].data;
        let stringJson = stringJsonTmp.substring(0, stringJsonTmp.length - 1); // Elimina la '}'
        stringJson += ',"read_at":"'+this.notifications.data.notifications[i].read_at+'"';
        stringJson += ',"time":"'+this.notifications.data.notifications[i].time+'"}';
        this.notificationRol.push(JSON.parse(stringJson));
      }
    });
  },
  computed: {    
    ...mapState("modCore", ["user"]),
    ...mapState("modRequest", ["notifications"]),
  },
  methods:{
    ...mapMutations("modCore", ["setUser"]),
    ...mapActions("modRequest", [
      "actGetNotifications",
      "actUpdateStateNtftn",
    ]),

    closeSession(){
      clear()
      this.$router.push({ path: '/' });
    },

    routeTo(idSol,id){
      this.actUpdateStateNtftn({id});

      if(this.user.core_role_id === 1){ // Rol Solicitante
        //this.$router.push({ path: '/consulrequest/'+idSol })
        window.location.assign('/consulrequest/'+idSol)
      }
      if(this.user.core_role_id === 2 || this.user.core_role_id === 7){ // Rol RRLL Tiquetes
        //this.$router.push({ path: '/approverTks/'+idSol })
        window.location.assign('/approverTks/'+idSol)
      }
      if(this.user.core_role_id === 3){ // Rol aprobador solicitud
        //this.$router.push({ path: '/approverSol/'+idSol })
        window.location.assign('/approverSol/'+idSol)
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.cont-heading {

  h1 {
    font-size: 18px;

    @media (min-width: 768px) {
      font-size: 24px;
    }
  }
  
  a:hover {
    color: rgb(39, 39, 39);
  }

  .cont-user-info {
    .cont-txt {
      .name {
        color: #1c3a4e;
        font-weight: 500;
        font-size: 12px;
      }

      .desc {
        color: #454545;
        font-size: 10px;
      }
      .dropdown {
        .dropdown-menu.show {
  background: #FFFFFF;
  width: auto !important;
  border: 1px solid #B0BEC5;
  border-radius: 8px;
  padding: 4px;
}
      }

    }

    .cont-symbol {
      border-left: 1px solid #454545;
      padding: 0 10px;
      margin-left: 15px;
    }



  }
  .notification {
    position: relative;
    display: inline-block;
    border-radius: 0px;
  }

  .notification .badge {
    position: absolute;
    top: -10px;
    right: -10px;
    padding: 5px 10px;
    border-radius: 10%;
    background-color: red;
    color: white;
    font-size: 12px;
  }

  .text {
    background: #ffffff;
    color: #454545;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-size: 12px;
    line-height: 12px;
  }
  .text2 {
    background-color: #eae8e4;
    color: #454545;
    font-family: "Open Sans";
    font-weight: normal;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 12px;
  }
  
  .centerImg1 {
    width: 10px;
    height: 10px;
    //position: absolute;
    //left: 50%;
    top: 100%; 
    //margin-left: -8px;
    //margin-top: 8px;
    float: right;
    //clear: right;
  }
}

  
.reloj-letras{
  position: absolute;
  top: 21%;
  left: 10%;

  /* Subtítulos */
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 30px;
  /* Neutral / White */
  color: #FFFFFF;
}


</style>